export default __webpack_public_path__ + "static/media/aboutus.d22d01f8.jpg";